import dynamic from 'next/dynamic';
// solution for client-side dynamic urls for responsive images.
// eventually should fully lean into the capabilities of next/image
// https://nextjs.org/docs/basic-features/image-optimization
const LSTVImage = dynamic(() => import('./_LSTVImageClient'), { ssr: false });
export default LSTVImage;
